<section class="section-boutiques">

  <div class="header-section">
    <h2 class="titre-section">Nos cafés jeux en boutique</h2>
  </div>

  <div class="frise-boutiques">

    <a class="boutique-item" target="_blank" *ngFor="let boutique of boutiques" [href]="boutique.lien">

      <div class="bg-image" [style.background-image]="'url(' + boutique.image + ')'"></div>

      <div class="bulle-info">
        <div class="contenu-bulle">
          <p class="intro">Animations à la boutique de</p>
          <h3>{{ boutique.ville }}</h3>
          <p class="adresse">{{ boutique.adresse }}</p>
        </div>
      </div>

    </a>

  </div>

</section>
